//import { history, FC, useState, useEffect, useMemo, React } from "react"
import {  FC, useState, useEffect, useMemo } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { ErrorMessage } from "@hookform/error-message";
import { KTSVG } from "../../../smallnation/helpers";
import { Link } from 'react-router-dom';
import { EditCompanyBasic } from "./editcompanybasic";
import { EditCompanyUsersList } from "./EditCompanyUsersList";
import { PerksList } from "./perkslist";
import { CompanyVideoUpload } from "./companyVideoUpload";
//import { CompEditJobanyVideoUpload } from "./companyVideoUpload";

//import { useForm } from "react-hookform";
import { useForm } from "react-hook-form";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
import {  useLocation, useHistory } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UsNumberValidate from "../../modules/utility/usNumberValidate";
import { CompanyJobApplications } from "./companyjobapplications";
import { CompanyOpenJobs } from "./companyOpenJobs";
import { CompanyPendingJobs } from "./companyPendingJobs";
import { CompanyFilledJobs } from "./companyFilledJobs";
import { CompanyExpiredJobs } from "./companyExpiredJobs";
import { Breadcrumb } from "react-bootstrap";

const CompanyDetails: FC = () => {
  const intl = useIntl();
  let history = useHistory();
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [companyProf, setCompanyProfile] = useState([]);
  const [companyinfo, setCompanyInfo] = useState([]);
  const [companyDisplayName, setCompanyDisplayName] = useState([]);
  const red = "red";
  var companytitle_name;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyId = queryParams.get('companyId');
  const [userList, setUsersList] = useState([]);


  const tabpane = queryParams.get('tab');
  
 // alert(tabpane);
  var tabToShow:any='';
if(tabpane == null){
  tabToShow = '1';
}
else {
  tabToShow = tabpane;
}
//alert(tabToShow);
function getTabPane(tabid:any) {
  tabToShow = `${tabid}`;
  
}

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  useEffect(() => {

   
  }, []);

  return (
    
    <>   
      <PageTitle breadcrumbs={[]}>{companyDisplayName}</PageTitle>
      <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6 acc-act border-bottom ">
  <li className="nav-item">
    <a
      className={tabToShow == 1 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_1"
      onClick={() => getTabPane('1')}
    >
      Basic Edit
    </a>
  </li>
  <li className="nav-item">
    <a
      className={tabToShow == 2 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_2"
      id="2"
      onClick={() => getTabPane('2')}
    >
      Company Users
    </a>
  </li>
  <li className="nav-item">
    <a
      className={tabToShow == 3 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_3"
      onClick={() => getTabPane('3')}
    >
      Perks List
    </a>
  </li>

  <li className="nav-item">
    <a
      className={tabToShow == 5 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_5"
      onClick={() => getTabPane('5')}
    >
      Current Jobs
    </a>
  </li>

  <li className="nav-item">
    <a
      className={tabToShow == 6 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_6"
      onClick={() => getTabPane('6')}
    >
      Pending Jobs
    </a>
  </li>

  <li className="nav-item">
    <a
      className={tabToShow == 7 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_7"
      onClick={() => getTabPane('7')}
    >
      Filled Jobs
    </a>
  </li>

  <li className="nav-item">
    <a
      className={tabToShow == 8 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_8"
      onClick={() => getTabPane('8')}
    >
      Expired Jobs
    </a>
  </li>


  <li className="nav-item">
    <a
      className={tabToShow == 4 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_4"
      onClick={() => getTabPane('4')}
    >
      Job Applications
    </a>
  </li>

  <li className="nav-item">
    <a
      className={tabToShow == 9 ? "nav-link active " : "nav-link"}
      data-bs-toggle="tab"
      href="#kt_tab_pane_9"
      onClick={() => getTabPane('9')}
    >
      Video
    </a>
  </li>
</ul>
<div className="tab-content" id="myTabContent">
  <div className={tabToShow == 1 ? "tab-pane fade active show" : "tab-pane fade"}  id="kt_tab_pane_1"  role="tabpanel">
    <EditCompanyBasic />
  </div>
  <div className={tabToShow == 2 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_2" role="tabpanel">
   <EditCompanyUsersList />
  </div>
  <div className={tabToShow == 3 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_3" role="tabpanel">
  <PerksList></PerksList>
  </div>

  <div className={tabToShow == 5 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_5" role="tabpanel">
  <CompanyOpenJobs></CompanyOpenJobs>
  </div>

  <div className={tabToShow == 6 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_6" role="tabpanel">
  <CompanyPendingJobs></CompanyPendingJobs>
  </div>

  <div className={tabToShow == 7 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_7" role="tabpanel">
  <CompanyFilledJobs></CompanyFilledJobs>
  </div>

  <div className={tabToShow == 8 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_8" role="tabpanel">
  <CompanyExpiredJobs></CompanyExpiredJobs>
  </div>

  <div className={tabToShow == 4 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_4" role="tabpanel">
  <CompanyJobApplications></CompanyJobApplications>
  </div>

  <div className={tabToShow == 9 ? "tab-pane fade active show" : "tab-pane fade"} id="kt_tab_pane_9" role="tabpanel">
  <CompanyVideoUpload></CompanyVideoUpload>
  </div>

</div>
    </>
  )
}
export { CompanyDetails }